// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zIWIVVcPOL2zJhsJZxaM{margin-bottom:12px}.nNLFb36jM0eZNXIHnhC7{padding:11px 8px 11px 11px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/CountrySelect/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA,CAEF,sBACE,0BAAA","sourcesContent":[".countrySelect {\n  margin-bottom: 12px;\n}\n.textField {\n  padding: 11px 8px 11px 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countrySelect": `zIWIVVcPOL2zJhsJZxaM`,
	"textField": `nNLFb36jM0eZNXIHnhC7`
};
export default ___CSS_LOADER_EXPORT___;
